import React, {useEffect, useState} from 'react';
import {Controller} from "react-hook-form";
import debounce from 'lodash/debounce'
import {Autocomplete, TextField} from "@mui/material";

function ConversionEventSelect({control, errors, options = []}) {
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState("");

    useEffect(() => {
        if (!open) {
            setSearch("");
        }
    }, [open]);

    const handleSearch = debounce(searchTerm => {
        setSearch(searchTerm);
    }, 800);

    return (
        <Controller
            render={({field: {onChange, ...props}}) => (
                <Autocomplete
                    id="conversion-event-name-select"
                    open={open}
                    onOpen={() => {
                        setOpen(true);
                    }}
                    onClose={() => {
                        setOpen(false);
                    }}
                    isOptionEqualToValue={(option, value) => {
                        if (option?.id === value?.id) {
                            return true;
                        }
                        if (value === null) {
                            return true;
                        }
                    }}
                    getOptionLabel={(option) => option?.name ? option?.name : ""}
                    options={options}
                    renderInput={params => (
                        <TextField
                            {...params}
                            error={!!errors?.conversionAction}
                            variant="outlined"
                            margin="dense"
                            size="small"
                            placeholder="Select a conversion event name"
                            value={search}
                            onChange={e => handleSearch(e?.target?.value)}
                            label="Conversion Event Name"
                            slotProps={{
                                inputLabel: {
                                    shrink: true
                                }
                            }}
                        />
                    )}
                    onChange={(e, selectedObject) => {
                        onChange(selectedObject);
                    }}
                    {...props}
                />
            )}
            rules={{required: false}}
            name="conversionAction"
            control={control}
            defaultValue={null}
            onChange={([, data]) => data}
        />
    );
}

export default ConversionEventSelect;